// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__lqzoP","footer_link":"Footer_footer_link__aMw0U"};